import { useStaticQuery, graphql } from 'gatsby';


export const useGuidesData = () => {
  const { allDatoCmsMaieuticalGuide: { nodes } } = useStaticQuery(
    graphql`
      query guideQuery {
        allDatoCmsMaieuticalGuide(filter: {disciplina: {eq: "mathx"}}) {
            nodes {
              id
              titolo
              stud
            }
          }
      }
  `,
  );

  return nodes;
};
